var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRounds({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 291,
    height: 162,
    viewBox: "0 0 291 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "url(#paint0_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 6,
    r: 6,
    fill: "url(#paint1_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 6,
    r: 6,
    fill: "url(#paint2_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 6,
    r: 6,
    fill: "url(#paint3_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 6,
    r: 6,
    fill: "url(#paint4_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 6,
    r: 6,
    fill: "url(#paint5_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 6,
    r: 6,
    fill: "url(#paint6_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223,
    cy: 6,
    r: 6,
    fill: "url(#paint7_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254,
    cy: 6,
    r: 6,
    fill: "url(#paint8_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285,
    cy: 6,
    r: 6,
    fill: "url(#paint9_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 31,
    r: 6,
    fill: "url(#paint10_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 31,
    r: 6,
    fill: "url(#paint11_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 31,
    r: 6,
    fill: "url(#paint12_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 31,
    r: 6,
    fill: "url(#paint13_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 31,
    r: 6,
    fill: "url(#paint14_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 31,
    r: 6,
    fill: "url(#paint15_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 31,
    r: 6,
    fill: "url(#paint16_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223,
    cy: 31,
    r: 6,
    fill: "url(#paint17_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254,
    cy: 31,
    r: 6,
    fill: "url(#paint18_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285,
    cy: 31,
    r: 6,
    fill: "url(#paint19_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 56,
    r: 6,
    fill: "url(#paint20_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 56,
    r: 6,
    fill: "url(#paint21_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 56,
    r: 6,
    fill: "url(#paint22_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 56,
    r: 6,
    fill: "url(#paint23_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 56,
    r: 6,
    fill: "url(#paint24_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 56,
    r: 6,
    fill: "url(#paint25_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 56,
    r: 6,
    fill: "url(#paint26_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223,
    cy: 56,
    r: 6,
    fill: "url(#paint27_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254,
    cy: 56,
    r: 6,
    fill: "url(#paint28_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285,
    cy: 56,
    r: 6,
    fill: "url(#paint29_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 81,
    r: 6,
    fill: "url(#paint30_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 81,
    r: 6,
    fill: "url(#paint31_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 81,
    r: 6,
    fill: "url(#paint32_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 81,
    r: 6,
    fill: "url(#paint33_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 81,
    r: 6,
    fill: "url(#paint34_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 81,
    r: 6,
    fill: "url(#paint35_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 81,
    r: 6,
    fill: "url(#paint36_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223,
    cy: 81,
    r: 6,
    fill: "url(#paint37_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254,
    cy: 81,
    r: 6,
    fill: "url(#paint38_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285,
    cy: 81,
    r: 6,
    fill: "url(#paint39_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 106,
    r: 6,
    fill: "url(#paint40_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 106,
    r: 6,
    fill: "url(#paint41_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 106,
    r: 6,
    fill: "url(#paint42_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 106,
    r: 6,
    fill: "url(#paint43_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 106,
    r: 6,
    fill: "url(#paint44_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 106,
    r: 6,
    fill: "url(#paint45_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 106,
    r: 6,
    fill: "url(#paint46_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223,
    cy: 106,
    r: 6,
    fill: "url(#paint47_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254,
    cy: 106,
    r: 6,
    fill: "url(#paint48_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285,
    cy: 106,
    r: 6,
    fill: "url(#paint49_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 131,
    r: 6,
    fill: "url(#paint50_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 131,
    r: 6,
    fill: "url(#paint51_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 131,
    r: 6,
    fill: "url(#paint52_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 131,
    r: 6,
    fill: "url(#paint53_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 131,
    r: 6,
    fill: "url(#paint54_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 131,
    r: 6,
    fill: "url(#paint55_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 131,
    r: 6,
    fill: "url(#paint56_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223,
    cy: 131,
    r: 6,
    fill: "url(#paint57_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254,
    cy: 131,
    r: 6,
    fill: "url(#paint58_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285,
    cy: 131,
    r: 6,
    fill: "url(#paint59_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 156,
    r: 6,
    fill: "url(#paint60_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 156,
    r: 6,
    fill: "url(#paint61_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 156,
    r: 6,
    fill: "url(#paint62_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 156,
    r: 6,
    fill: "url(#paint63_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 156,
    r: 6,
    fill: "url(#paint64_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 156,
    r: 6,
    fill: "url(#paint65_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 156,
    r: 6,
    fill: "url(#paint66_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223,
    cy: 156,
    r: 6,
    fill: "url(#paint67_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254,
    cy: 156,
    r: 6,
    fill: "url(#paint68_linear_218_192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285,
    cy: 156,
    r: 6,
    fill: "url(#paint69_linear_218_192)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_218_192",
    x1: 6,
    y1: 0,
    x2: 6,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_218_192",
    x1: 37,
    y1: 0,
    x2: 37,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_218_192",
    x1: 68,
    y1: 0,
    x2: 68,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_218_192",
    x1: 99,
    y1: 0,
    x2: 99,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_218_192",
    x1: 130,
    y1: 0,
    x2: 130,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_218_192",
    x1: 161,
    y1: 0,
    x2: 161,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_218_192",
    x1: 192,
    y1: 0,
    x2: 192,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_218_192",
    x1: 223,
    y1: 0,
    x2: 223,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_218_192",
    x1: 254,
    y1: 0,
    x2: 254,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_218_192",
    x1: 285,
    y1: 0,
    x2: 285,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_218_192",
    x1: 6,
    y1: 25,
    x2: 6,
    y2: 37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_218_192",
    x1: 37,
    y1: 25,
    x2: 37,
    y2: 37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_218_192",
    x1: 68,
    y1: 25,
    x2: 68,
    y2: 37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_218_192",
    x1: 99,
    y1: 25,
    x2: 99,
    y2: 37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_218_192",
    x1: 130,
    y1: 25,
    x2: 130,
    y2: 37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_218_192",
    x1: 161,
    y1: 25,
    x2: 161,
    y2: 37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_218_192",
    x1: 192,
    y1: 25,
    x2: 192,
    y2: 37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_218_192",
    x1: 223,
    y1: 25,
    x2: 223,
    y2: 37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_218_192",
    x1: 254,
    y1: 25,
    x2: 254,
    y2: 37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_218_192",
    x1: 285,
    y1: 25,
    x2: 285,
    y2: 37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_218_192",
    x1: 6,
    y1: 50,
    x2: 6,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_218_192",
    x1: 37,
    y1: 50,
    x2: 37,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_218_192",
    x1: 68,
    y1: 50,
    x2: 68,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_218_192",
    x1: 99,
    y1: 50,
    x2: 99,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_218_192",
    x1: 130,
    y1: 50,
    x2: 130,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_218_192",
    x1: 161,
    y1: 50,
    x2: 161,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_218_192",
    x1: 192,
    y1: 50,
    x2: 192,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_218_192",
    x1: 223,
    y1: 50,
    x2: 223,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_218_192",
    x1: 254,
    y1: 50,
    x2: 254,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_218_192",
    x1: 285,
    y1: 50,
    x2: 285,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_218_192",
    x1: 6,
    y1: 75,
    x2: 6,
    y2: 87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_218_192",
    x1: 37,
    y1: 75,
    x2: 37,
    y2: 87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_218_192",
    x1: 68,
    y1: 75,
    x2: 68,
    y2: 87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_218_192",
    x1: 99,
    y1: 75,
    x2: 99,
    y2: 87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_218_192",
    x1: 130,
    y1: 75,
    x2: 130,
    y2: 87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_218_192",
    x1: 161,
    y1: 75,
    x2: 161,
    y2: 87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_218_192",
    x1: 192,
    y1: 75,
    x2: 192,
    y2: 87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_218_192",
    x1: 223,
    y1: 75,
    x2: 223,
    y2: 87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_218_192",
    x1: 254,
    y1: 75,
    x2: 254,
    y2: 87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_218_192",
    x1: 285,
    y1: 75,
    x2: 285,
    y2: 87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_218_192",
    x1: 6,
    y1: 100,
    x2: 6,
    y2: 112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_218_192",
    x1: 37,
    y1: 100,
    x2: 37,
    y2: 112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_218_192",
    x1: 68,
    y1: 100,
    x2: 68,
    y2: 112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_218_192",
    x1: 99,
    y1: 100,
    x2: 99,
    y2: 112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_218_192",
    x1: 130,
    y1: 100,
    x2: 130,
    y2: 112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_218_192",
    x1: 161,
    y1: 100,
    x2: 161,
    y2: 112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_218_192",
    x1: 192,
    y1: 100,
    x2: 192,
    y2: 112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_218_192",
    x1: 223,
    y1: 100,
    x2: 223,
    y2: 112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_218_192",
    x1: 254,
    y1: 100,
    x2: 254,
    y2: 112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_218_192",
    x1: 285,
    y1: 100,
    x2: 285,
    y2: 112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_218_192",
    x1: 6,
    y1: 125,
    x2: 6,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_218_192",
    x1: 37,
    y1: 125,
    x2: 37,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_218_192",
    x1: 68,
    y1: 125,
    x2: 68,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_218_192",
    x1: 99,
    y1: 125,
    x2: 99,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_218_192",
    x1: 130,
    y1: 125,
    x2: 130,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_218_192",
    x1: 161,
    y1: 125,
    x2: 161,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_218_192",
    x1: 192,
    y1: 125,
    x2: 192,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_218_192",
    x1: 223,
    y1: 125,
    x2: 223,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_218_192",
    x1: 254,
    y1: 125,
    x2: 254,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_218_192",
    x1: 285,
    y1: 125,
    x2: 285,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_218_192",
    x1: 6,
    y1: 150,
    x2: 6,
    y2: 162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_218_192",
    x1: 37,
    y1: 150,
    x2: 37,
    y2: 162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_218_192",
    x1: 68,
    y1: 150,
    x2: 68,
    y2: 162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_218_192",
    x1: 99,
    y1: 150,
    x2: 99,
    y2: 162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_218_192",
    x1: 130,
    y1: 150,
    x2: 130,
    y2: 162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_218_192",
    x1: 161,
    y1: 150,
    x2: 161,
    y2: 162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_218_192",
    x1: 192,
    y1: 150,
    x2: 192,
    y2: 162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_218_192",
    x1: 223,
    y1: 150,
    x2: 223,
    y2: 162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_218_192",
    x1: 254,
    y1: 150,
    x2: 254,
    y2: 162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_218_192",
    x1: 285,
    y1: 150,
    x2: 285,
    y2: 162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47220"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRounds);
export default __webpack_public_path__ + "static/media/rounds.44be88166d1d185a2ded9efbcc1be263.svg";
export { ForwardRef as ReactComponent };